module.exports = __webpack_public_path__ + "static/media/messaging-icon.7191d270.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/messaging-icon.svg
// module id = 1369
// module chunks = 0